import { render, staticRenderFns } from "./ListTemplate.vue?vue&type=template&id=6f42284d&scoped=true"
import script from "./ListTemplate.vue?vue&type=script&lang=js"
export * from "./ListTemplate.vue?vue&type=script&lang=js"
import style0 from "./ListTemplate.vue?vue&type=style&index=0&id=6f42284d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f42284d",
  null
  
)

export default component.exports